import React, { lazy, useEffect, useState } from "react";
import { RiSearchLine } from "react-icons/ri";
import { FaAngleLeft } from "react-icons/fa";
import flag_2 from "./../../assets/img/tarh-parcham-iran-psdtarh2.png";
import MainLayout from "../../layout/main";
import { ApiEndpoints, useApiCall } from "../../api";
import Loading from "../../component/loading";
import { useTableDataGenerator } from "../../helper/common";
import { appRoutes, useAppNavigation } from "../../router/routes";
import { Table } from "../../component/table";
import { SelectOption } from "../../component/selectOption";
import { LIST_PAGE_SIZE } from "../../config";
import { IoClose, IoImagesOutline } from "react-icons/io5";
import { storageApi } from "../../storage/storageApi";
import { useAlert } from "react-alert";
import { Input } from "../../component/input";
import { logDOM } from "@testing-library/react";
import { Tooltip } from "../../component/Tooltip";

const UserListPage = () => {
  const { navigate, queryParameter } = useAppNavigation();
  const [searchUser, setSearchUser] = useState("");
  const [department, setDepartment] = useState("");
  const [sazman, setSazman] = useState("");
  const [sazmanId, setSazmanId] = useState("");
  const [city, setCity] = useState("");
  const [cityId, setCityId] = useState(0);
  const [cPage, setCPage] = useState(queryParameter().get("page"));
  const userProfile = storageApi.useGetUser();
  const [userTypeId, setUserTypeId] = useState("");
  const [userType, setUserType] = useState("");
  const [userId, setUserId] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [fullName, setFullName] = useState("");
  const [dastgahType, setDastgahType] = useState("");
  const [sakhtarDastgahType, setSakhtarDastgahType] = useState("");
  const [moavenat, setMoavenat] = useState("");
  const [state, setState] = useState(0);
  const [stateId, setStateId] = useState("");
  const [majmooeId, setMajmooeId] = useState(0);
  const [majmooe, setMajmooe] = useState(0);
  const alert = useAlert();
  useEffect(() => {
    handleGetUsers();
  }, []);
  const handleGetUsers = () => {
    usersObj = fetchUsers();
  };
  useEffect(() => {
    if (cPage > 0) {
      handleGetUsers();
    }
  }, [cPage]);
  let [[usersObj], { fetch: fetchUsers, loading }] = useApiCall({
    endpoints: ApiEndpoints.user.listByAdmin,
    payload: {
      page: cPage,
      sazman_id: sazman,
      majmooe_id: department,
      state_id: stateId,
      city_id: city,
      search: searchUser,
      userType: userType,
    },
    lazy: true,
  });

  const [[cityList, departmentList, stateList]] = useApiCall({
    endpoints: [
      ApiEndpoints.user.cityList,
      ApiEndpoints.user.departmentList,
      ApiEndpoints.user.stateList,
    ],
  });
  useEffect(() => {
    if (searchUser !== "") {
      setTablePage(0);
      if (cPage === 1) {
        handleGetUsers();
      }
    }
  }, [searchUser]);
  const [[sazmanList]] = useApiCall({
    endpoints: [ApiEndpoints.user.organizationList],
  });

  const [[profile]] = useApiCall({
    endpoints: [ApiEndpoints.user.profile],
  });

  const [, { loading: userInfoLoading, fetch: getUserInfo }] = useApiCall({
    endpoints: [ApiEndpoints.user.userUpdateGet],
    payload: { userId },
    lazy: true,
  });
  const [, { loading: userPartialUpdateLoading, fetch: userPartialUpdate }] =
    useApiCall({
      endpoints: [ApiEndpoints.user.userPartialUpdate],
      payload: {
        userTypeId,
        userId,
      },
      lazy: true,
    });
  const [, { loading: userUpdateLoading, fetch: userUpdate }] = useApiCall({
    endpoints: [ApiEndpoints.user.userUpdate],
    payload: {
      mobileNumber,
      fullName,
      userTypeId,
      dastgahType,
      sakhtarDastgahType,
      moavenat,
      state,
      cityId,
      majmooeId,
      sazmanId,
      userId,
    },
    lazy: true,
  });
  useEffect(() => {
    if (
      profile &&
      (userProfile.role === "state_organization_manager" ||
        userProfile.role === "organization_manager")
    ) {
      setMajmooe(profile?.data.department);
    }
  }, [profile]);
  const submitForm = async () => {
    const [updateResult] = await userUpdate();
    if (updateResult.isOk) {
      alert.success("بروزرسانی موفق");
      handleGetUsers();
      hideModal();
    }
  };
  const removeFilters = () => {
    window.location.reload();
    // setSearchProgramName("");
    // setSearchUser("");
    // setSearchUserType("USER_NAME");
    // setStatus("");
    // setCity("");
    // setDepartment("");
    // setSazman("");
    // setMonasebat("");
  };
  useEffect(() => {
    if (
      sazman !== "" ||
      city !== "" ||
      department !== "" ||
      stateId !== "" ||
      userType !== ""
    ) {
      setTablePage(0);
      if (cPage === 1) {
        handleGetUsers();
      }
    }
  }, [sazman, city, department, stateId, userType]);
  const { data, setPage, currentPage, totalPageCount } = useTableDataGenerator(
    usersObj?.data?.data ?? [],
    {
      filters: {},
    },
    usersObj?.data?.count,
  );
  const setTablePage = (pageNumber) => {
    setCPage(pageNumber + 1);
  };
  const goUserProgramList = (item) => {
    navigate(appRoutes.programList({ userId: item.id }));
  };
  const [name, setName] = useState("");
  const [showModal, setShowModal] = useState(false);
  const onChangeModal = (i) => {
    setName(i.full_name);
    setUserId(i.id);
    setShowModal(true);
  };
  useEffect(() => {
    if (showModal && userId !== 0) {
      getUserInfoObj();
    }
  }, [userId]);
  const getUserInfoObj = async () => {
    const [userInfoObj] = await getUserInfo();
    if (userInfoObj?.data) {
      const user = userInfoObj.data;
      setFullName(user?.full_name);
      setUserTypeId(user?.user_type);
      setState(user?.state);
      setCityId(user?.city);
      setDastgahType(user?.dastgah_type);
      setMajmooeId(user?.majmooe);
      setSakhtarDastgahType(user?.sakhtar_dastgah_tabee_type);
      setSazmanId(user?.sazman);
      setMoavenat(user?.moavenat);
      setMobileNumber(user?.mobile_number);
    }
  };
  const hideModal = () => {
    setShowModal(false);
  };
  const [modalData, setModalData] = useState({
    data: [{ adii: "کاربر عادی", sazmanii: "سازمانی-استانی" }],
  });
  const sectionList = [
    {
      id: "keshvari",
      title: "کشوری",
    },
    {
      id: "lashkari",
      title: "لشکری",
    },
  ];
  const structureList = [
    {
      id: "setadi_markazi",
      title: "ستادی/مرکزی",
    },
    {
      id: "ostani",
      title: "استانی",
    },
  ];
  const userLevelOptions = [
    { label: "کاربر عادی", value: "customer" },
    {
      label: "سازمانی - استانی",
      value: "state_organization_manager",
    },
  ];
  const adminUserLevelOptions = [
    { label: "کاربر عادی", value: "customer" },
    { label: "ناظر", value: "state_manager" },
    { label: "مدیر سازمان", value: "organization_manager" },
    {
      label: "سازمانی - استانی",
      value: "state_organization_manager",
    },
    { label: "مدیر کل", value: "admin" },
  ];
  const stateUserLevelOptions = [
    { label: "کاربر عادی", value: "customer" },
    { label: "ناظر", value: "state_manager" },
    {
      label: "سازمانی - استانی",
      value: "state_organization_manager",
    },
  ];
  const orgUserLevelOptions = [
    { label: "کاربر عادی", value: "customer" },
    { label: "مدیر سازمان", value: "organization_manager" },
    {
      label: "سازمانی - استانی",
      value: "state_organization_manager",
    },
  ];
  const orgStateUserLevelOptions = [
    { label: "کاربر عادی", value: "customer" },
    {
      label: "سازمانی - استانی",
      value: "state_organization_manager",
    },
  ];
  return (
    <MainLayout>
      <div className="content-style flex flex-col gap-8 md:p-8 p-4 bg-gray-100 h-full  shadow-sm w-full">
        {/* sec1 */}
        <div className="sec1 w-full bg-greenblue-light h-auto rounded-3xl relative md:p-8 p-4">
          <img src={flag_2} className=" absolute left-0 top-0 md:h-42 h-24" />
          <div className="flex flex-col gap-8 justify-center items-center md:w-[60%] w-full md:mt-0 mt-4 mx-auto">
            <div>
              <div className="md:text-3xl text-xl text-center font-bold">
                <span className=" text-greenblue">فهرست کاربران</span>
              </div>
            </div>
            <div className=" w-full space-y-3">
              <div className="relative form-field">
                <input
                  type="text"
                  placeholder="شماره تلفن همراه یا نام و نام خانوادگی را جستجو کنید..."
                  className=" w-full p-4  border-2 border-gray-100 rounded-lg pr-10 pl-12"
                  onChange={(e) => setSearchUser(e.target.value)}
                />
                <div className=" absolute top-[50%] -translate-y-[50%] text-gray-400 right-2">
                  <RiSearchLine size={24} />
                </div>
              </div>
              <div
                className={
                  "w-full justify-around items-center flex md:flex-row flex-col"
                }
              >
                {userProfile.role === "admin" && (
                  <SelectOption
                    classLabel="text-slate-800  font-bold"
                    classInput="w-full"
                    className=" w-[200px] p-3 rounded-lg"
                    label={"استان:"}
                    value={stateId}
                    options={stateList?.data.map((c) => ({
                      label: c.name,
                      value: c.id,
                    }))}
                    onChange={(e) => {
                      setStateId(e.value);
                    }}
                  />
                )}
                <SelectOption
                  classLabel="text-slate-800  font-bold"
                  classInput="w-full"
                  className="md:w-[200px] w-full p-3 rounded-lg"
                  label={"شهر:"}
                  value={city}
                  options={cityList?.data
                    .filter((item) => {
                      if (
                        profile &&
                        (userProfile.role === "state_organization_manager" ||
                          userProfile.role === "state_manager")
                      ) {
                        return item.state === profile?.data.state;
                      } else if (stateId && stateId !== "") {
                        return item.state === stateId;
                      } else {
                        return true;
                      }
                    })
                    .map((c) => ({
                      label: c.name,
                      value: c.id,
                    }))}
                  onChange={(e) => {
                    setCity(e.value);
                  }}
                />
                {userProfile.role === "organization_manager" ? (
                  <SelectOption
                    classLabel="text-slate-800  font-bold"
                    classInput="w-full"
                    className=" w-[200px] p-3 rounded-lg"
                    label={"استان:"}
                    value={stateId}
                    options={stateList?.data.map((c) => ({
                      label: c.name,
                      value: c.id,
                    }))}
                    onChange={(e) => {
                      setStateId(e.value);
                    }}
                  />
                ) : (
                  <SelectOption
                    classLabel="text-slate-800  font-bold"
                    classInput="w-full"
                    className=" w-[200px] p-3 rounded-lg"
                    label={"مجموعه:"}
                    value={department}
                    options={departmentList?.data.map((c) => ({
                      label: c.title,
                      value: c.id,
                    }))}
                    onChange={(e) => {
                      setDepartment(e.value);
                    }}
                  />
                )}
              </div>
              <div
                className={
                  "md:w-[500px] w-full justify-around items-center flex flex-col md:flex-row"
                }
              >
                <SelectOption
                  classLabel="text-slate-800  font-bold"
                  classInput="w-full"
                  className=" w-[200px] p-3 rounded-lg"
                  label={"سازمان:"}
                  value={sazman}
                  options={sazmanList?.data
                    .filter((i) => {
                      return department
                        ? i.majmooe === department
                        : majmooe !== 0
                          ? i.majmooe === majmooe
                          : true;
                    })
                    .map((c) => ({
                      label: c.title,
                      value: c.id,
                    }))}
                  onChange={(e) => {
                    setSazman(e.value);
                  }}
                />

                <SelectOption
                  label="دسترسی کاربر:"
                  classLabel="text-slate-800  font-bold text-nowrap"
                  className="md:w-[180px] w-full p-3 rounded-lg"
                  classInput="w-full"
                  value={userType}
                  options={
                    userProfile.role === "state_manager"
                      ? stateUserLevelOptions
                      : userProfile.role === "organization_manager"
                        ? orgUserLevelOptions
                        : userProfile.role === "state_organization_manager"
                          ? orgStateUserLevelOptions
                          : adminUserLevelOptions
                  }
                  onChange={(e) => {
                    setUserType(e.value);
                  }}
                />
              </div>
              <div className={"w-full justify-around items-center flex"}>
                <button
                  onClick={removeFilters}
                  className="cursor-pointer flex items-center gap-1 bg-blue-100 text-blue-500 px-3 py-2 rounded-xl"
                >
                  حذف فیلترها x
                </button>
              </div>
            </div>
          </div>
        </div>

        <Table
          loading={loading}
          data={data}
          hasPagination
          totalPageCount={totalPageCount}
          totalCount={usersObj?.data.count}
          setPage={setTablePage}
          currentPage={currentPage}
          header={[
            {
              name: "ردیف",
              width: 1,
              render: (i) =>
                cPage == null
                  ? i.rowIndex
                  : i.rowIndex + (cPage - 1) * LIST_PAGE_SIZE,
            },
            {
              name: "نام و نام خانوادگی",
              width: 1,
              render: (i) => i.full_name,
            },
            {
              name: "معاونت",
              width: 2,
              render: (i) => i.moavenat,
            },
            {
              name: "شهرستان",
              width: 1,
              render: (i) => i.city_name,
            },
            {
              name:
                userProfile.role === "organization_manager"
                  ? "استان"
                  : "مجموعه",
              width: 2,
              render: (i) =>
                userProfile.role === "organization_manager"
                  ? i.state_name
                  : i.majmooe,
            },
            {
              name: "سازمان",
              width: 1,
              render: (i) => i.sazman,
            },
            {
              name: "شماره همراه",
              width: 1,
              render: (i) => i.mobile_number,
            },
            {
              name: "شماره ثابت",
              width: 1,
              render: (i) => i.phone_number,
            },
            {
              name: "عملیات",
              width: 2,
              render: (i) => (
                <div className="flex gap-2">
                  <button
                    onClick={() => goUserProgramList(i)}
                    className="flex items-center gap-1 bg-blue-100 text-blue-500 px-3 py-2 rounded-xl"
                  >
                    مشاهده برنامه ها
                    <FaAngleLeft />
                  </button>
                  {(userProfile.role === "organization_manager" ||
                    userProfile.role === "admin") && (
                    <button
                      onClick={() => onChangeModal(i)}
                      className="flex items-center gap-1 bg-blue-100 text-blue-500 px-3 py-2 rounded-xl"
                    >
                      ویرایش
                    </button>
                  )}
                </div>
              ),
            },
          ]}
        />
      </div>
      {showModal && (
        <div
          className={`z-[10000] bg-gray-900 bg-opacity-40 w-screen h-screen  fixed top-0 left-0 overflow-y-scroll edit-modal`}
        >
          <div
            className="md:w-[768px] w-[350px] md:max-h-[900px] md:min-h-[400px]  rounded-xl p-8 bg-white absolute
           top-[50%] -translate-y-[50%] left-[50%] -translate-x-[50%] flex align-center flex-col"
          >
            <div className=" text-center text-lg font-semibold mb-4 ">
              <div
                className=" absolute left-6 top-6 z-40 p-2 text-gray-500"
                onClick={hideModal}
              >
                <IoClose size={24} className="cursor-pointer" />
              </div>
              ویرایش {name}
            </div>
            <div className="flex f justify-center flex-col mt-10 w-full self-center">
              {userProfile.role === "organization_manager" && (
                <>
                  <span className={"px-3 text-[12px] right-2"}>
                    دسترسی کاربر
                  </span>
                  <SelectOption
                    classLabel="text-slate-800  font-bold"
                    className=" w-[200px] p-3 rounded-lg"
                    value={modalData}
                    options={userLevelOptions}
                    onChange={(e) => {
                      setUserTypeId(e.value);
                    }}
                  />
                </>
              )}
              {userProfile.role === "admin" && (
                <>
                  <div className="grid md:grid-cols-2 grid-cols-1 md:gap-4 gap-6 w-full">
                    <div className="form-field w-full relative mt-2">
                      <Input
                        type="text"
                        placeholder="نام و نام خانوادگی"
                        label="نام و نام خانوادگی"
                        value={fullName}
                        onChange={(e) => {
                          setFullName(e);
                        }}
                      />
                    </div>
                    <div className="form-field w-full relative mt-2">
                      <SelectOption
                        label="دسترسی کاربر"
                        value={userTypeId}
                        options={adminUserLevelOptions}
                        onChange={(e) => {
                          setUserTypeId(e.value);
                        }}
                      />
                    </div>
                    <div className="form-field w-full relative mt-2">
                      <SelectOption
                        label="استان"
                        value={state}
                        options={stateList?.data?.map((c) => ({
                          label: c.name,
                          value: c.id,
                        }))}
                        onChange={(e) => {
                          setState(e.value);
                        }}
                      />
                    </div>
                    <div className="form-field w-full relative mt-2">
                      <SelectOption
                        label="شهرستان"
                        value={cityId}
                        options={cityList?.data
                          ?.filter((c) => c.state === state)
                          ?.map((c) => ({
                            label: c.name,
                            value: c.id,
                          }))}
                        onChange={(e) => {
                          setCityId(e.value);
                        }}
                      />
                    </div>
                    <div className="form-field w-full relative mt-2">
                      <SelectOption
                        label="نوع دستگاه"
                        value={dastgahType}
                        options={sectionList.map((c) => ({
                          label: c.title,
                          value: c.id,
                        }))}
                        onChange={(e) => {
                          setDastgahType(e.value);
                        }}
                      />
                    </div>
                    <div className="form-field w-full relative mt-2">
                      <SelectOption
                        label={"ساختار دستگاه تابعه"}
                        value={sakhtarDastgahType}
                        options={structureList.map((c) => ({
                          label: c.title,
                          value: c.id,
                        }))}
                        onChange={(e) => setSakhtarDastgahType(e.value)}
                      />
                    </div>
                    <div className="form-field w-full relative mt-2">
                      <SelectOption
                        label="نام مجموعه"
                        value={majmooeId}
                        options={departmentList?.data?.map((c) => ({
                          label: c.title,
                          value: c.id,
                        }))}
                        onChange={(e) => {
                          setMajmooeId(e.value);
                        }}
                      />
                    </div>
                    <div className="form-field w-full relative mt-2">
                      <SelectOption
                        label="نام سازمان"
                        value={sazmanId}
                        options={sazmanList?.data?.map((c) => ({
                          label: c.title,
                          value: c.id,
                        }))}
                        onChange={(e) => {
                          setSazmanId(e.value);
                        }}
                      />
                    </div>
                    <div className="form-field w-full relative mt-2">
                      <Input
                        type="text"
                        placeholder="نام معاونت"
                        label="نام معاونت"
                        value={moavenat}
                        onChange={(e) => {
                          setMoavenat(e);
                        }}
                      />
                    </div>
                    <div className="form-field w-full relative mt-2">
                      <Input
                        type="text"
                        placeholder="شماره همراه"
                        label="شماره همراه"
                        value={mobileNumber}
                        onChange={(e) => {
                          setMobileNumber(e);
                        }}
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="flex justify-center mt-10">
              <button
                className="w-5/12 bg-green-600 text-white px-3 py-2 rounded-xl"
                onClick={submitForm}
              >
                ذخیره
                <Loading isLoading={userUpdateLoading} />
              </button>
            </div>
          </div>
        </div>
      )}
    </MainLayout>
  );
};

export default UserListPage;
